import { diff, createElement, unmount } from './diff.js';

// Store previous vnode for diffing
const containerVnodeMap = new WeakMap();

/**
 * Render a vnode tree to a container
 * @param {Object} vnode - Root vnode
 * @param {HTMLElement} container - DOM container
 */
export function render(vnode, container) {
    const oldVnode = containerVnodeMap.get(container) || null;

    // Clear container if this is first render
    if (oldVnode === null) {
        container.innerHTML = '';
    }

    diff(container, oldVnode, vnode, 0);
    containerVnodeMap.set(container, vnode);
}

/**
 * Unmount a rendered tree from container
 * @param {HTMLElement} container
 */
export function unmountRoot(container) {
    const vnode = containerVnodeMap.get(container);
    if (vnode) {
        unmount(vnode);
        container.innerHTML = '';
        containerVnodeMap.delete(container);
    }
}
